import useSWR from "swr";

import { TemplateVariableGroup } from "@/constants/message-template.constants";
import SWR_KEYS from "@/constants/swr-keys";
import messageTemplateService from "@/services/message-template.service";
import { RequestsBaseReturn } from "@/types/requests.types";

export type UseGetMessageTemplateTagsReturn = RequestsBaseReturn<TemplateVariableGroup[]>;

/** Busca as variáveis disponíveis no backend (GET /api/v1/CustomerTemplate/tags). */
const useGetMessageTemplateTags = (type?: string): UseGetMessageTemplateTagsReturn => {
  const {
    data = [],
    isValidating: isLoading,
    error,
  } = useSWR<TemplateVariableGroup[], Error>(
    `${SWR_KEYS.getMessageTemplateTags}-${type ?? "all"}`,
    () => messageTemplateService.getTags(type),
    { revalidateOnFocus: false }
  );

  return { data, isLoading, error };
};

export default useGetMessageTemplateTags;
